<template>
  <div v-if="pageData.total > 0" class="w-fit">
    <BlockUI :blocked="blockPageIndicator">
      <Paginator
        :first="pageData.from"
        :currentPage="pageData.current_page"
        :rows="pageData.per_page"
        :totalRecords="pageData.total"
        :rowsPerPageOptions="perPageOptions"
        @page="changePage"
      >
      </Paginator>
    </BlockUI>
  </div>
</template>

<script>
import Paginator from "primevue/paginator";
import BlockUI from "primevue/blockui";

export default {
  components: { Paginator, BlockUI },
  props: {
    pageData: {
      type: Object,
      default() {
        return {
          from: 1,
          current_page: 1,
          per_page: 1,
          total: 1,
        };
      },
    },
    perPageOptions: {
      type: Array,
      default() {
        return [10, 20, 30, 50];
      },
    },
    scrollToTop: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },
  data() {
    return {
      blockPageIndicator: false,
    };
  },
  methods: {
    getQueryStrings() {
      let queryStr = window.location.search,
        queryArr = queryStr.replace("?", "").split("&"),
        queryParams = [];

      for (let q = 0, qArrLength = queryArr.length; q < qArrLength; q++) {
        let qArr = queryArr[q].split("=");
        queryParams[qArr[0]] = qArr[1];
      }

      return _(queryParams).omitBy(_.isUndefined).omitBy(_.isNull).value();
    },
    changePage(event) {
      // let queryStringArray = _.omit(this.getQueryStrings(), [
      //   "page",
      //   "per_page",
      // ]);

      let queryStringArray = this.getQueryStrings();

      queryStringArray["page"] = event.page + 1;
      queryStringArray["per_page"] = event.rows;

      let queryStrings = [];

      _.forIn(queryStringArray, (value, key) => {
        queryStrings.push(key + "=" + value);
      });

      let url = this.pageData.path + "?" + queryStrings.join("&");

      this.$inertia.visit(url, {
        preserveScroll: true,
        onStart: (visit) => {
          this.blockPageIndicator = true;
        },
        onFinish: (visit) => {
          this.blockPageIndicator = false;
          if (this.scrollToTop == true) {
            window.scrollTo({ top: 0, behavior: "smooth" });
          }
        },
      });
    },
  },
};
</script>